import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import Modal from "react-bootstrap/Modal";
import ReactDropdown from "react-dropdown";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import UploadCustomerImage from "components/GenericComponent/UploadCustomerImage";
import { formatDayMonth, convertDate } from "utils/formatDate";
import { pushNotification } from "utils/notifications";
import userApi from "service/userApi";
import CustomerApi from "service/QuanLyKhachHang/DanhSachKhachHang/DanhSachKhachHangApi";
import NguonKhachHangApi from "service/nguonKhachHangApi";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import configsRole from "utils/configsRole";
import { useQuyen } from "utils/quyenNguoiDung";

const splitFullName = (fullName) => {
  const parts = fullName.trim().split(/\s+/);
  if (parts.length > 1) {
    return {
      LastName: parts[parts.length - 1],
      FirstName: parts.slice(0, parts.length - 1).join(" "),
    };
  }
  return { FirstName: fullName.trim(), LastName: "" };
};

export const ModalThemMoiVaSua = (props) => {
  const isEdit = props.editData && props.editData.CustomerId > 0;
  //Các quyền tab con của nhóm "Thông tin khách vay"
  const quyenThongTinKhac = useQuyen(
    configsRole.sRole.thongtinkhachvay_thongtinkhac
  );
  const quyenThanhPhanGiaDinh = useQuyen(
    configsRole.sRole.thongtinkhachvay_thanhphangiadinh
  );
  const quyenThongTinChoVay = useQuyen(
    configsRole.sRole.thongtinkhachvay_thongtinchovay
  );
  //Quyền cấp 3: tắt thì chỉ ẩn đúng ô đó, tab vẫn hiện bình thường
  const quyenGhiChu = useQuyen(
    configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu
  );
  const quyenThongTinKhacGiaDinh = useQuyen(
    configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac
  );
  //Tab đầu tiên còn hiển thị sẽ được gán active
  const tabDauTien = quyenThongTinChoVay
    ? "tab421"
    : quyenThongTinKhac
    ? "tab422"
    : quyenThanhPhanGiaDinh
    ? "tab423"
    : "";
  const initialObjKhachHang = useMemo(
    () => ({
      CustomerId: 0,
      CustomerName: "",
      Phone: "",
      CMT: "",
      Birthday: null,
      DateCMT: null,
      AddressCMT: "",
      Email: "",
      Address: "",
      HKTT: "",
      NguonKhId: 0,
      DebtLevel: "0",
      LoaiDoiTac: 1,
      UserName: "",
      Profession: "",
      WorkAddress: "",
      Income: "",
      PersonContact: "",
      PhoneContact: "",
      Note: "",
      NameWife: "",
      PhoneWife: "",
      ProfessionWife: "",
      NameFather: "",
      PhoneFather: "",
      ProfessionFather: "",
      NameMother: "",
      PhoneMother: "",
      ProfessionMother: "",
      NoteFamily: "",
      Img: "",
    }),
    [],
  );

  const [objKhachHang, setObjKhachHang] = useState(initialObjKhachHang);
  const [errors, setErrors] = useState({});
  const [nhanVienOption, setNhanVienOption] = useState([]);
  const [nguonKHOptions, setNguonKHOptions] = useState([]);
  const [tinhTrangNoOptions, setTinhTrangNoOptions] = useState([]);
  const [isFetchingDetail, setIsFetchingDetail] = useState(isEdit);
  const CustomerNameRef = useRef(null);
  const EmailRef = useRef(null);
  const loaiDoiTacOptions = useMemo(
    () => [
      { value: 0, label: "Chủ nợ" },
      { value: 1, label: "Khách hàng" },
    ],
    [],
  );

  const loadCombosAndData = useCallback(() => {
    Promise.all([
      userApi.combo2(),
      NguonKhachHangApi.getCombo(props.dbName),
      DoiTinhTrangNoApi.getListTinhTrangNo(),
    ])
      .then(([resUser, resNguonKH, resTinhTrangNo]) => {
        let formatNguonKH = [];
        let nvOptions = [];
        if (resUser.status === 200) {
          nvOptions = resUser.data
            .filter((item) => item.value !== "0")
            .map((item) => ({ ...item, value: String(item.value) }));
          setNhanVienOption(nvOptions);
        }

        if (resNguonKH.status === 200) {
          formatNguonKH = resNguonKH.data.map((item) => ({
            value: Number(item.value),
            label: item.label,
          }));
          setNguonKHOptions(formatNguonKH);
        }

        if (resTinhTrangNo.status === 200) {
          const formattedOptions = resTinhTrangNo.data.map((item) => ({
            value: String(item.Code),
            label: item.Name,
          }));
          setTinhTrangNoOptions(formattedOptions);
        }
        if (isEdit && props.dbName && props.editData.CustomerId) {
          const customerId = props.editData.CustomerId;
          const dbName = props.dbName;
          return CustomerApi.getById(customerId, dbName);
        } else if (!isEdit) {
          let defaultValues = {};
          if (nvOptions.length > 0) {
            defaultValues.UserName = nvOptions[0].value;
          }
          if (formatNguonKH.length > 1) {
            defaultValues.NguonKhId = formatNguonKH[1].value;
          } else if (formatNguonKH.length === 1) {
            defaultValues.NguonKhId = formatNguonKH[0].value;
          }
          setObjKhachHang((prev) => ({ ...prev, ...defaultValues }));
        }
      })
      .then((resDetail) => {
        if (isEdit && resDetail) {
          if (resDetail.status === 200 && resDetail.data) {
            const detailData = resDetail.data;
            const fullName = `${detailData.FirstName || ""} ${
              detailData.LastName || ""
            }`.trim();
            const parseApiDate = (dateString) => {
              const dateObj = convertDate(dateString);
              return dateObj === "" ? null : dateObj;
            };
            setObjKhachHang({
              ...initialObjKhachHang,
              ...detailData,
              CustomerName: fullName,
              DebtLevel: String(detailData.DebtLevel || 0),
              NguonKhId: Number(detailData.NguonKH_ID || 0),
              LoaiDoiTac: Number(detailData.IsCus ? 1 : 0),
              Birthday: parseApiDate(detailData.Birthday),
              DateCMT: parseApiDate(detailData.DateCMT),
            });
          } else {
            pushNotification(
              "Không tìm thấy chi tiết khách hàng.",
              "error",
              "TOP_CENTER",
              2000,
            );
          }
        }
      })
      .catch((e) => {
        console.error("Lỗi tải combo:", e);
      })
      .finally(() => {
        setIsFetchingDetail(false);
      });
  }, []);

  useEffect(() => {
    loadCombosAndData();
  }, []);

  const onChangeData = (field) => (event) => {
    const value = event.target.value;
    setObjKhachHang((prev) => ({ ...prev, [field]: value }));
  };

  const onChangeImg = (Img) => {
    setObjKhachHang((prev) => ({ ...prev, Img: Img }));
  };

  const onChangThuNhap = (event) => {
    const value = event.target.value;
    const re = /^[0-9\b]+$/;
    if (value === "" || re.test(value)) {
      setObjKhachHang((prev) => ({ ...prev, Income: value }));
    }
  };
  const onChangeNgaySinh = (date) => {
    setObjKhachHang((prev) => ({ ...prev, Birthday: date }));
  };
  const onChangeNgayCap = (date) => {
    setObjKhachHang((prev) => ({ ...prev, DateCMT: date }));
  };

  const handleDropdownSelect = (field) => (option) => {
    const value =
      field === "DebtLevel" || field === "UserName"
        ? String(option.value)
        : Number(option.value);
    setObjKhachHang((prev) => ({ ...prev, [field]: value }));
  };

  const validate = () => {
    let newErrors = {};
    let isValid = true;
    if (!objKhachHang.CustomerName) {
      newErrors.CustomerName = { message: "Nhập tên khách hàng" };
      isValid = false;
    }
    if (
      objKhachHang.Email &&
      !new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g).test(
        objKhachHang.Email,
      )
    ) {
      newErrors.Email = { message: "Email không đúng định dạng" };
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };
  const onSumit = useCallback(() => {
    if (!validate()) {
      if (errors.CustomerName) CustomerNameRef.current?.focus();
      else if (errors.Email) EmailRef.current?.focus();
      return;
    }
    const { FirstName, LastName } = splitFullName(objKhachHang.CustomerName);
    const dbNameForUpdate = isEdit ? props.dbName : null;
    const payload = {
      ...objKhachHang,
      FirstName: FirstName,
      LastName: LastName,
      Income: objKhachHang.Income ? parseInt(objKhachHang.Income) : 0,
      DebtLevel: parseInt(objKhachHang.DebtLevel),
      LoaiDoiTac: parseInt(objKhachHang.LoaiDoiTac),
      NguonKH_ID: parseInt(objKhachHang.NguonKhId),
      Birthday: objKhachHang.Birthday
        ? formatDayMonth(objKhachHang.Birthday)
        : null,
      DateCMT: objKhachHang.DateCMT
        ? formatDayMonth(objKhachHang.DateCMT)
        : null,
      IsCus: objKhachHang.LoaiDoiTac == 1,
      Img: objKhachHang.Img || "",
      NoteFamily: objKhachHang.NoteFamily || "",
      NameWife: objKhachHang.NameWife || "",
      PhoneWife: objKhachHang.PhoneWife || "",
      ProfessionWife: objKhachHang.ProfessionWife || "",
      NameFather: objKhachHang.NameFather || "",
      PhoneFather: objKhachHang.PhoneFather || "",
      ProfessionFather: objKhachHang.ProfessionFather || "",
      NameMother: objKhachHang.NameMother || "",
      PhoneMother: objKhachHang.PhoneMother || "",
      ProfessionMother: objKhachHang.ProfessionMother || "",
    };
    delete payload.NguonKhId;
    const apiCall = isEdit
      ? CustomerApi.update(payload.CustomerId, payload, dbNameForUpdate)
      : CustomerApi.create(payload);

    apiCall
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          const message = isEdit
            ? "Cập nhật thành công!"
            : "Thêm mới thành công!";
          pushNotification(message, "success", "TOP_CENTER", 2000);
          props.onSearch();
          props.onHide();
        } else {
          pushNotification(
            response.data?.Message || "Có lỗi xảy ra.",
            "error",
            "TOP_CENTER",
            2000,
          );
        }
      })
      .catch((error) => {
        pushNotification(
          error.response?.data?.Message || "Lỗi hệ thống.",
          "error",
          "TOP_CENTER",
          2000,
        );
      });
  }, [objKhachHang, errors]);

  const {
    CustomerName,
    Birthday,
    Phone,
    CMT,
    DateCMT,
    AddressCMT,
    Email,
    Address,
    HKTT,
    NguonKhId,
    DebtLevel,
    LoaiDoiTac,
    UserName,
    Profession,
    WorkAddress,
    Income,
    PersonContact,
    PhoneContact,
    Note,
  } = objKhachHang;
  const modalTitle = isEdit
    ? "Chỉnh sửa thông tin khách hàng"
    : "Thêm mới khách hàng";
  const submitText = isEdit ? "Cập nhật" : "Thêm mới";

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      className="modal-new modal fade text-left popup-detail modal show"
    >
      <Modal.Header>
        <h4 className="modal-title mt-1 color7-bold" id="myModalLabel16">
          <span style={{ marginLeft: 10, marginRight: 5, marginTop: 10 }}>
            <img
              src="/app-assets/images/icon-tao-moi-don-nhap-hang.png"
              alt="Khách hàng"
            />
          </span>
          {modalTitle}
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        {isFetchingDetail ? (
          <div
            className="loader loader-default is-active"
            style={{ minHeight: "400px" }}
          ></div>
        ) : (
          <form className="form form-horizontal">
            <div className="form-body">
              <div className="p-2 mb-2 thong-tin-khach-vay">
                <div className="row">
                  <div className="col-md-3 d-flex justify-content-center align-items-center">
                    <UploadCustomerImage
                      onChange={onChangeImg}
                      image={objKhachHang.Img}
                      Code={props.dbName}
                    />
                  </div>
                  <div className="col-md-9">
                    <div className="row">
                      <div className="col-md-4 form-group">
                        <label className="color7-bold">
                          Họ Tên <span className="text-danger">*</span>
                        </label>
                        <input
                          className="form-control input-sm"
                          value={CustomerName}
                          onChange={onChangeData("CustomerName")}
                          ref={CustomerNameRef}
                          placeholder="Nhập họ tên"
                        />
                        {errors.CustomerName && (
                          <span className="canh-bao-red">
                            {errors.CustomerName.message}
                          </span>
                        )}
                      </div>
                      <div className="col-md-4 form-group">
                        <label className="color7-bold">Ngày sinh</label>
                        <DateTimePicker
                          onChange={onChangeNgaySinh}
                          value={Birthday}
                          name="Birthday"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                      <div className="col-md-4 form-group">
                        <label className="color7-bold">Số CCCD</label>
                        <input
                          className="form-control input-sm"
                          onChange={onChangeData("CMT")}
                          value={CMT}
                          placeholder="Nhập số CCCD"
                        />
                      </div>
                      <div className="col-md-4 form-group">
                        <label className="color7-bold">Số điện thoại</label>
                        <input
                          className="form-control input-sm"
                          onChange={onChangeData("Phone")}
                          value={Phone}
                          placeholder="Nhập số điện thoại"
                        />
                      </div>
                      <div className="col-md-4 form-group">
                        <label className="color7-bold">Địa chỉ</label>
                        <input
                          className="form-control input-sm"
                          onChange={onChangeData("Address")}
                          value={Address}
                          placeholder="Nhập địa chỉ"
                        />
                      </div>
                      <div className="col-md-4 form-group">
                        <label className="color7-bold">Ngày cấp CCCD</label>
                        <DateTimePicker
                          onChange={onChangeNgayCap}
                          value={DateCMT}
                          name="DateCMT"
                          placeholder="dd/mm/yyyy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <ul className="nav nav-tabs mt-1 bg-tab">
                {quyenThongTinChoVay && (
                <li className="nav-item">
                  <a
                    className={"nav-link" + (tabDauTien === "tab421" ? " active" : "")}
                    data-toggle="tab"
                    href="#tab421"
                    aria-expanded="true"
                  >
                    <h4>
                      <img
                        src="/app-assets/images/icon-thong-tin-vay-v2.png"
                        alt="vay"
                      />
                      &nbsp;Thông tin cho vay
                    </h4>
                  </a>
                </li>
                )}
                {quyenThongTinKhac && (
                <li className="nav-item">
                  <a
                    className={"nav-link" + (tabDauTien === "tab422" ? " active" : "")}
                    data-toggle="tab"
                    href="#tab422"
                    aria-expanded="false"
                  >
                    <h4>
                      <img
                        src="/app-assets/images/icon-thong-tin-vay-v2.png"
                        alt="khac"
                      />
                      &nbsp;Thông tin khác
                    </h4>
                  </a>
                </li>
                )}
                {quyenThanhPhanGiaDinh && (
                <li className="nav-item">
                  <a
                    className={"nav-link" + (tabDauTien === "tab423" ? " active" : "")}
                    data-toggle="tab"
                    href="#tab423"
                    aria-expanded="false"
                  >
                    <h4>
                      <img
                        src="/app-assets/images/icon-thong-tin-gia-dinh-xanh.png"
                        alt="gd"
                      />
                      &nbsp;Thành phần gia đình
                    </h4>
                  </a>
                </li>
                )}
              </ul>
              <div className="tab-content px-1 pt-1 bg-content-tab">
                {/* TAB 1: THÔNG TIN CHO VAY*/}
                <div
                  className={"tab-pane" + (tabDauTien === "tab421" ? " active" : "")}
                  id="tab421"
                  aria-expanded="true"
                  aria-labelledby="base-tab1"
                >
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="color7-bold">Nguồn khách hàng</label>
                        <ReactDropdown
                          options={nguonKHOptions}
                          onChange={handleDropdownSelect("NguonKhId")}
                          value={
                            nguonKHOptions.find(
                              (opt) => opt.value === NguonKhId,
                            ) || null
                          }
                          controlClassName="form-control input-sm"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="color7-bold">Tình trạng</label>
                        <ReactDropdown
                          options={tinhTrangNoOptions}
                          onChange={handleDropdownSelect("DebtLevel")}
                          value={
                            tinhTrangNoOptions.find(
                              (opt) => opt.value === DebtLevel,
                            ) || null
                          }
                          controlClassName="form-control input-sm"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="color7-bold">Loại đối tác</label>
                        <ReactDropdown
                          options={loaiDoiTacOptions}
                          onChange={handleDropdownSelect("LoaiDoiTac")}
                          value={
                            loaiDoiTacOptions.find(
                              (opt) => opt.value === LoaiDoiTac,
                            ) || null
                          }
                          controlClassName="form-control input-sm"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label className="color7-bold">Người theo dõi</label>
                        <ReactDropdown
                          options={nhanVienOption}
                          onChange={handleDropdownSelect("UserName")}
                          value={
                            nhanVienOption.find(
                              (opt) => opt.value === UserName,
                            ) || null
                          }
                          controlClassName="form-control input-sm"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* TAB 2: THÔNG TIN KHÁC*/}
                <div
                  className={"tab-pane" + (tabDauTien === "tab422" ? " active" : "")}
                  id="tab422"
                  aria-labelledby="base-tab2"
                >
                  <div className="row">
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelText="Nghề nghiệp"
                        labelClass="label-control text-bold"
                        wrapperClass="form-group"
                        value={Profession}
                        inputProps={{
                          onChange: onChangeData("Profession"),
                          placeholder: "Nhập nghề nghiệp",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelText="Người liên hệ"
                        labelClass="label-control text-bold"
                        wrapperClass="form-group"
                        value={PersonContact}
                        inputProps={{
                          onChange: onChangeData("PersonContact"),
                          placeholder: "Nhập họ tên người liên hệ",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelText="Nơi cấp CCCD"
                        labelClass="label-control text-bold"
                        wrapperClass="form-group"
                        value={AddressCMT}
                        inputProps={{
                          onChange: onChangeData("AddressCMT"),
                          placeholder: "Nhập nơi cấp CCCD",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelText="Nơi làm việc"
                        labelClass="label-control text-bold"
                        wrapperClass="form-group"
                        value={WorkAddress}
                        inputProps={{
                          onChange: onChangeData("WorkAddress"),
                          placeholder: "Nhập nơi làm việc",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelText="Số điện thoại người liên hệ"
                        labelClass="label-control text-bold"
                        wrapperClass="form-group"
                        value={PhoneContact}
                        inputProps={{
                          onChange: onChangeData("PhoneContact"),
                          placeholder: "Nhập số điện thoại",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelText="Hộ khẩu thường trú"
                        labelClass="label-control text-bold"
                        wrapperClass="form-group"
                        value={HKTT}
                        inputProps={{
                          onChange: onChangeData("HKTT"),
                          placeholder: "Nhập địa chỉ thường trú",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelText="Email"
                        labelClass="label-control text-bold"
                        wrapperClass="form-group"
                        value={Email}
                        inputProps={{
                          onChange: onChangeData("Email"),
                          ref: EmailRef,
                          placeholder: "Nhập email",
                        }}
                        error={errors.Email}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelText="Thu nhập"
                        labelClass="label-control text-bold"
                        wrapperClass="form-group"
                        value={Income}
                        inputProps={{
                          onChange: onChangThuNhap,
                          placeholder: "Nhập thu nhập",
                        }}
                      />
                    </div>
                    {quyenGhiChu && (
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="label-control text-bold">
                            Ghi chú
                          </label>
                          <textarea
                            rows="3"
                            className="textarea-customer input-sm"
                            placeholder=""
                            value={Note}
                            onChange={onChangeData("Note")}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* TAB 3: THÀNH PHẦN GIA ĐÌNH*/}
                <div
                  className={"tab-pane" + (tabDauTien === "tab423" ? " active" : "")}
                  id="tab423"
                  aria-labelledby="base-tab2"
                >
                  <div className="row">
                    {/* Hàng 1: Vợ/Chồng */}
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Họ tên chồng/vợ"
                        inputProps={{
                          onChange: onChangeData("NameWife"),
                          value: objKhachHang.NameWife || "",
                          placeholder: "Nhập họ tên",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Số điện thoại chồng/vợ"
                        inputProps={{
                          onChange: onChangeData("PhoneWife"),
                          value: objKhachHang.PhoneWife || "",
                          placeholder: "Nhập số điện thoại",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Nghề nghiệp chồng/vợ"
                        inputProps={{
                          onChange: onChangeData("ProfessionWife"),
                          value: objKhachHang.ProfessionWife || "",
                          placeholder: "Nhập nghề nghiệp",
                        }}
                      />
                    </div>

                    {/* Hàng 2: Bố */}
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Họ tên bố"
                        inputProps={{
                          onChange: onChangeData("NameFather"),
                          value: objKhachHang.NameFather || "",
                          placeholder: "Nhập họ tên",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Số điện thoại bố"
                        inputProps={{
                          onChange: onChangeData("PhoneFather"),
                          value: objKhachHang.PhoneFather || "",
                          placeholder: "Nhập số điện thoại",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Nghề nghiệp bố"
                        inputProps={{
                          onChange: onChangeData("ProfessionFather"),
                          value: objKhachHang.ProfessionFather || "",
                          placeholder: "Nhập nghề nghiệp",
                        }}
                      />
                    </div>

                    {/* Hàng 3: Mẹ */}
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Họ tên mẹ"
                        inputProps={{
                          onChange: onChangeData("NameMother"),
                          value: objKhachHang.NameMother || "",
                          placeholder: "Nhập họ tên",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Số điện thoại mẹ"
                        inputProps={{
                          onChange: onChangeData("PhoneMother"),
                          value: objKhachHang.PhoneMother || "",
                          placeholder: "Nhập số điện thoại",
                        }}
                      />
                    </div>
                    <div className="col-md-4">
                      <TextInputOnRow
                        labelClass="label-control text-bold"
                        inputClass="form-control input-sm"
                        wrapperClass="form-group"
                        labelText="Nghề nghiệp mẹ"
                        inputProps={{
                          onChange: onChangeData("ProfessionMother"),
                          value: objKhachHang.ProfessionMother || "",
                          placeholder: "Nhập nghề nghiệp",
                        }}
                      />
                    </div>

                    {/* Hàng 4: Ghi chú */}
                    {quyenThongTinKhacGiaDinh && (
                      <div className="col-md-12">
                        <div className="form-group">
                          <label className="label-control text-bold">
                            Thông tin khác
                          </label>
                          <textarea
                            rows="3"
                            className="textarea-customer input-sm"
                            placeholder=""
                            value={objKhachHang.NoteFamily || ""}
                            onChange={onChangeData("NoteFamily")}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <a
          className="btn btn-new-main btn-checknew"
          href={() => false}
          onClick={onSumit}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>{" "}
          {submitText}
        </a>
        <a
          type="button"
          className="btn btn-new-main btn-closenew"
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
